var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "d-flex w-100" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-column", attrs: { id: "cancellations" } },
      [
        _vm._m(0),
        _c("div", { staticClass: "flex-grow-1 overflow-hidden d-flex" }, [
          _c(
            "div",
            { staticClass: "card card-no-margin" },
            [
              _c("h4", [
                _vm._v(
                  _vm._s(_vm.onlineboxes_total) +
                    " box connectées | " +
                    _vm._s(_vm.incidentCount) +
                    " problèmes"
                )
              ]),
              _c("m-list", {
                ref: "onlineboxeslist",
                attrs: {
                  dynamic: true,
                  items: _vm.onlineboxes,
                  "item-value": "or_id",
                  "item-height": 30,
                  limit: _vm.onlineboxes_limit,
                  skip: _vm.onlineboxes_skip,
                  total: _vm.onlineboxes_total,
                  bgstrip: false
                },
                on: { itemclick: _vm.goBox },
                scopedSlots: _vm._u([
                  {
                    key: "ths",
                    fn: function(ref) {
                      return [
                        _c("th", { staticStyle: { width: "60px" } }, [
                          _vm._v(" # ")
                        ]),
                        _c("th", [_vm._v(" Etablissement ")]),
                        _c("th", [_vm._v(" Contact ")]),
                        _c("th", [_vm._v(" Bénéficiaire ")]),
                        _c("th", { staticStyle: { width: "80px" } }, [
                          _vm._v(" Box ver. ")
                        ]),
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v(" Abonnement ")
                        ]),
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v(" Paiement ")
                        ])
                      ]
                    }
                  },
                  {
                    key: "tds",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "td",
                          {
                            class: _vm.getBoxBackground(item),
                            staticStyle: { width: "60px" }
                          },
                          [_vm._v(" " + _vm._s(item.en_id) + " ")]
                        ),
                        _c("td", { class: _vm.getBoxBackground(item) }, [
                          _vm._v(" " + _vm._s(item.es_name) + " ")
                        ]),
                        _c("td", { class: _vm.getBoxBackground(item) }, [
                          _vm._v(
                            " " +
                              _vm._s(item.co_invoice_firstname) +
                              " " +
                              _vm._s(item.co_invoice_name) +
                              " "
                          )
                        ]),
                        _c("td", { class: _vm.getBoxBackground(item) }, [
                          _vm._v(" " + _vm._s(item.en_fullname) + " ")
                        ]),
                        _c(
                          "td",
                          {
                            class: _vm.getBoxBackground(item),
                            staticStyle: { width: "80px" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.bo_hardwareinfo.appemotivi_version
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "td",
                          {
                            class: _vm.getBoxBackground(item) + " text-center"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "indicatorLight",
                                class: {
                                  isActive: item.su_state === 2,
                                  isStopping: item.su_state === 1,
                                  isStopped: item.su_state === 0
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.su_state !== null ? "A" : null
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "td",
                          {
                            class: _vm.getBoxBackground(item) + " text-center"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "indicatorLight",
                                class: {
                                  notExists:
                                    item.su_remote_status === "trialing",
                                  isActive: item.su_remote_status === "active",
                                  isStopping:
                                    item.su_remote_status === "problem",
                                  isStopped:
                                    item.su_remote_status === "cancelled"
                                },
                                attrs: {
                                  title:
                                    "#" +
                                    item.su_id +
                                    ": " +
                                    item.su_remote_raw_status
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.su_gocardlessid
                                        ? "G"
                                        : item.su_stripeid
                                        ? "S"
                                        : null
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "row header-emotivi mb-3 justify-content-around align-items-end"
      },
      [
        _c("div", { staticClass: "col" }, [
          _c("h1", [_vm._v("Box connectées")])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }